export const walletRequestHeading = [
    { name: "ID" },
    { name: "FULLNAME" },
    { name: "AMOUNT" },
    { name: "APPROVE" },
]